<template>
    <li class="cards" >
        <a :href="url" :title="title" class="card-link"></a>
        <img :src="image" alt="" class="cover-img">
        <h3>{{title}}</h3>
        <full-description
            :price="price"
            :description="description"
            :url="url"
            :type="type"
            :title="title"
        />
    </li>
</template>

<script>
import FullDescription from './FullDescription';
import { hasIn } from 'ramda';

export default {
    name: "List",
    props: {
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        image: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },
    computed: {
        price() {
            let price = hasIn('price', this.data)? this.data.price : '';
            return price;
        }
    },
    components: {
        FullDescription
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Item.vue